<template>
  <div class="widget">
    <header v-if="header">
      <h2>
        <slot name="heading"></slot>
      </h2>
    </header>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Boolean,
      default: true
    }
  }
};
</script>
